'use client'

import Image from 'next/image'
import { getMediaUrl } from 'src/_helpers/client/getMediaUrl'
import TextContent from 'src/components/blocks/types/TextContent'
import Typography from 'src/components/design-system/Typography'
import { getLocalizedThumb } from 'src/_helpers/getLocalizedThumb'

export default function TextWithPhoto({ block, locale, variant = '' }) {
  const translation = block.translations?.[locale] || {}
  const alt = translation?.alt

  const thumb = getLocalizedThumb(block, 'text_with_photo', locale)
  const thumbUrl = thumb ? getMediaUrl(thumb.url, thumb.version) : null

  return (
    <section
      className={`${variant === 'journal' ? 'py-80 bg-dark-blue-dark-blue6 full-width-shadow-dark-blue-dark-blue6' : 'my-64'} d:px-40 px-16 ${block.type.value}`}
      id={`${block.uuid}`}
    >
      <div className="grid xl:grid-cols-[950px_1fr] d:grid-cols-2  gap-44 items-start">
        <TextContent block={block} locale={locale} variant={variant} />
        {thumbUrl && (
          <figure className="d:sticky top-146 d:ml-auto d:order-last order-first flex flex-col gap-8 xl:max-w-[750px] max-w-665 w-full">
            <Image className="w-full" src={thumbUrl} alt={alt} width={thumb.width} height={thumb.height} />
            {alt && (
              <div className="flex items-center gap-x-10">
                <span className="bg-style1 w-11 h-11 rounded-full"></span>
                <Typography variant="body3" component="figcaption" color="text-dark-blue-dark-blue1">
                  {alt}
                </Typography>
              </div>
            )}
          </figure>
        )}
      </div>
    </section>
  )
}
